@let sharedLoading = sharedLoading$ | async;


<app-top-bar [isBack]="true" [title]="'Напишіть ваше звернення'"></app-top-bar>
<div class="support-create-container">
  @if (sessionStorageService.retrieve('userType') === 'dispatcher') {
    <div class="service-block">
      <mat-form-field appearance="outline"
                      class="message-form-field"
                      [subscriptSizing]="'dynamic'">
        <mat-select [(ngModel)]="service"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="changeService($event)"
                    panelClass="city-select-panel"
                    placeholder="Оберіть місто">
          @for (s of serviceList; track s.id) {
            <mat-option [value]="s.id">
              {{s?.city?.loc_name ? s.city.loc_name : s.city.key}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  <div class="create-block block-background"
       [ngClass]="{'create-block-service': sessionStorageService.retrieve('userType') === 'dispatcher'}"
       [formGroup]="ticketForm"
  >
    <mat-form-field class="create-form-field default-background"
                    [ngStyle]="{'max-height': vcr()?.get(0) ? 'calc(var(--app-height, 100dvh) - 272px)' : 'calc(var(--app-height, 100dvh) - 176px)'}"
                    appearance="outline">
      <textarea matInput
                focus-me
                cdkTextareaAutosize
                formControlName="description"
                #message
                maxlength="500"
                placeholder="Розкажіть що саме пішло не так">
        </textarea>
      <mat-hint class="hint-color" align="start">{{message.value.length}} / 500</mat-hint>
    </mat-form-field>

    <div class="input-chat-block block-background"
         [ngClass]="{'input-chat-block-resize': vcr()?.get(0)}"
    >
      <div class="attached-files">
        <ng-container #container></ng-container>
      </div>
      <div class="input-line">
        <div class="message-form-field pseudo-button"
             [ngStyle]="{'opacity': components.length === 3 ? '0.5' : '1'}"
             (click)="!vcr()?.get(2) && !sendMessageLoading ? openBottomSheet() : null">
          <mat-icon class="accent-color">attach_file</mat-icon>
        </div>
        <button class="main-button positive-button accent-color-background button-border-color-accent"
                (click)="submitForm()"
                [disabled]="ticketForm.invalid || sendMessageLoading || sharedLoading"
                [ngStyle]="{'opacity': ticketForm.invalid || sendMessageLoading || sharedLoading ? '0.5' : '1'}"
                mat-flat-button>Надіслати</button>
      </div>
    </div>
  </div>
</div>
